
<form [formGroup]="getFormGroup()">
    <div class="p-2 ">
        <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
            Asset Information
        </div>

        <div class="m-4 mt-3">
          <div class="row mb-1">
            <label class="col-6 mt-2 text-start mogo-bold" for="chep-pallets-input">Chep (Blue) Pallets:</label>
            <label class="col-6 mt-2 text-start mogo-bold" for="loscam-pallets-input">Loscam (Grey) Pallets:</label>
        </div>
        <div class="row mb-1">
            <div class="col-6">
                <input id="chep-pallets-input" type="number" class="col-6 form-control" [class.is-invalid]="formGroup.hasError('assetInformationRequired') && getFormGroup().touched" formControlName="chepPallets"  placeholder="Number of Chep Pallets" />
            </div>
            <div class="col-6">
                <input id="loscam-pallets-input" type="number" class="col-6 form-control" [class.is-invalid]="formGroup.hasError('assetInformationRequired') && getFormGroup().touched" formControlName="loscamPallets"  placeholder="Number of Loscam Pallets" />
            </div>
        </div>
        <div class="row mb-1">
            <label class="col-6 mt-2 text-start mogo-bold"  for="green-pallets-input">Green (Keg) Pallets:</label>
            <label class="col-6 mt-2 text-start mogo-bold"  for="other-pallets-input">Other Pallets:</label>
        </div>
        <div class="row mb-1">
            <div class="col-6">
                <input id="green-pallets-input" type="number" class="form-control" [class.is-invalid]="formGroup.hasError('assetInformationRequired') && getFormGroup().touched" formControlName="greenPallets"  placeholder="Number of Green Pallets" />
            </div>
            <div class="col-6">
                <input id="other-pallets-input" type="number" class="form-control" [class.is-invalid]="formGroup.hasError('assetInformationRequired') && getFormGroup().touched" formControlName="otherPallets"  placeholder="Number of Other Pallets" />
            </div>
        </div>

        <div class="row mb-1">
            <label class="col-12 mt-2 text-start mogo-bold"  for="total-lifts-input">Total Full Lifts:</label>
        </div>
        <div class="row mb-1">
            <div class="col-12">
                <input id="total-lifts-input" type="number" class="form-control" formControlName="totalLifts"  placeholder="Total Lifts" />
            </div>
        </div>
        </div>

    </div>
</form>
